import React, { useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

const dummyData = [
    {
        id: 1,
        name: 'John Doe',
        visaMaster: 1200,
        unionPay: 800,
        bankPull: 500,
        otc: 300,
        atm: 200,
        internetBanking: 400,
        grandTotal: 3400
    },
    {
        id: 2,
        name: 'Jane Smith',
        visaMaster: 900,
        unionPay: 600,
        bankPull: 400,
        otc: 250,
        atm: 150,
        internetBanking: 350,
        grandTotal: 2650
    },
    {
        id: 3,
        name: 'Alice Brown',
        visaMaster: 1500,
        unionPay: 1000,
        bankPull: 700,
        otc: 400,
        atm: 300,
        internetBanking: 600,
        grandTotal: 4500
    },
    {
        id: 4,
        name: 'Bob White',
        visaMaster: 1100,
        unionPay: 700,
        bankPull: 350,
        otc: 200,
        atm: 100,
        internetBanking: 250,
        grandTotal: 2700
    }
];

const MerchantWalletRequest = () => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [data, setData] = useState(dummyData);
    const dt = React.useRef(null);

    const filterData = () => {
        let filtered = dummyData;
        if (startDate) {
            filtered = filtered.filter((row) => new Date(row.createdDate) >= new Date(startDate));
        }
        if (endDate) {
            filtered = filtered.filter((row) => new Date(row.createdDate) <= new Date(endDate));
        }
        setData(filtered);
    };

    const exportCSV = () => {
        if (dt.current) {
            dt.current.exportCSV();
        }
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <div className="actions">
                    <Button
                        tooltip="Edit"
                        icon="pi pi-pencil"
                        tooltipOptions={{ position: 'top' }}
                        disabled={['Pending', 'Rejected'].includes(rowData?.statusName) || (rowData?.statusName === 'Approved' && rowData?.isActive === 'N') ? true : false}
                        // onClick={() => EditUiElement(rowData)}
                        className="p-button-rounded p-button-primary mr-2"
                    />
                    <Button
                        tooltip="View Details"
                        tooltipOptions={{ position: 'top' }}
                        icon="pi pi-eye"
                        // onClick={() => ViewUiElement(rowData)}
                        className="p-button-rounded"
                        style={{ backgroundColor: '#F2AC57', border: 'none' }}
                    />
                </div>
            </>
        );
    };

    return (
        <div className="p-4">
            <div className="flex justify-content-between align-items-center mb-3">
                <h3>Merchant Fee Report</h3>
                <div className="flex gap-2">
                    <Calendar value={startDate} onChange={(e) => setStartDate(e.value)} placeholder="Start Date" dateFormat="yy-mm-dd" showIcon />
                    <Calendar value={endDate} onChange={(e) => setEndDate(e.value)} placeholder="End Date" dateFormat="yy-mm-dd" showIcon />
                </div>
            </div>
            <DataTable
                ref={dt}
                value={data}
                paginator
                rows={5}
                className="p-datatable-sm"
                footer={
                    <div className="flex justify-content-end">
                        <Button label="Export CSV" icon="pi pi-download" className="p-button-info p-button-sm" onClick={exportCSV} />
                    </div>
                }
            >
                <Column header="Sr" body={(rowData, options) => options.rowIndex + 1} style={{ width: '60px' }} />
                <Column field="name" header="Name" />
                <Column field="visaMaster" header="Total Visa/Master" />
                <Column field="unionPay" header="Total Union Pay" />
                <Column field="bankPull" header="Total Bank Pull" />
                <Column field="otc" header="Total OTC" />
                <Column field="atm" header="Total ATM" />
                <Column field="internetBanking" header="Internet Banking" />
                <Column field="grandTotal" header="Grand Total" />
                <Column header="Actions" body={actionBodyTemplate} className="Table__ActionHeading__CentredAlign" />
            </DataTable>
        </div>
    );
};

export default MerchantWalletRequest;
